export default __webpack_public_path__ + "6b23908b7960ee446ad22aa892f66ba3.png";